import { get } from 'lodash-es';

export const getBookState = (editor) => editor.book;

export const getBook = (editor) => editor.book.data;

export const getBookId = (book) => get(book, '_id');

export const getBookLayout = (book) => get(book, 'layout', {});
